import { Component, OnInit } from '@angular/core';
import { MIAUser, AuthenticationService } from '@mobileia/authentication';
import { CartService } from 'src/app/services/cart.service';
import { ActivatedRoute } from '@angular/router';
import { TransactionService } from 'src/app/services/transaction.service';

@Component({
  selector: 'app-step-five',
  templateUrl: './step-five.component.html',
  styleUrls: ['./step-five.component.scss']
})
export class StepFiveComponent implements OnInit {

  currentUser = new MIAUser();
  transactionId = 0;
  paymentType = 1;

  constructor(
    protected cartService: CartService,
    protected authService: AuthenticationService,
    protected transactionService: TransactionService,
    protected route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.cartService.clean();
    this.loadTransaction();
    this.loadUser();
  }

  loadTransaction() {
    this.transactionId = this.transactionService.transactionCurrent.id;
    this.paymentType = this.transactionService.transactionCurrent.payment_type;
  }
  
  loadUser() {
    this.authService.currentUser.subscribe(data => {
      if (data == null) {
        return;
      }
      this.currentUser = data;
    });
  }
}
